import styled, { keyframes } from 'styled-components';
import { Container, Row, Col, Table, Form, Button } from 'react-bootstrap';

// Styled components

export const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const StyledContainer = styled(Container)`
  animation: ${fadeIn} 0.6s ease-out;
`;

export const TableContainer = styled.div`
  position: relative;
  max-height: 80vh; /* Chiều cao tối đa cho vùng cuộn */
  overflow-y: auto; /* Cho phép cuộn dọc phần dữ liệu */
`;

export const StyledTable = styled(Table)`
  width: 100%;
  border-collapse: collapse;

  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    border-bottom: 2px solid #ccc;
    padding: 8px; /* Khoảng cách giữa nội dung và viền */
    text-align: left; /* Căn trái nội dung */
  }

  tbody tr:nth-child(odd) {
    background-color: #f0f8ff; /* Nền xanh nhạt cho dòng lẻ */
  }

  tbody tr:nth-child(even) {
    background-color: white; /* Nền trắng cho dòng chẵn */
  }

  tbody td {
    padding: 8px; /* Khoảng cách giữa nội dung và viền */
    max-width: 200px; /* Giới hạn độ rộng cột */

    /* Tự xuống dòng khi quá dài */
    white-space: normal;
    word-wrap: break-word;      /* Hỗ trợ trình duyệt cũ */
    overflow-wrap: break-word;  /* Chuẩn mới hơn */
    border: 0.5px solid #ccc; /* Đường viền ngăn cách cột */
  }
`;

export const StyledTableHeader = styled.th`
  background-color: #f0f0f0;
  color: #333;
`;

export const SpacingRow = styled(Row)`
  margin-bottom: 20px;
`;

// Styled Buttons
export const CreateButton = styled.button`
  padding: 10px 20px;
  background: linear-gradient(135deg, #007bff, #0056b3);
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 10px;
  box-shadow: 0 4px 8px rgba(0, 123, 255, 0.3);
  transition: all 0.3s ease;

  &:hover {
    background: linear-gradient(135deg, #0056b3, #007bff);
    transform: translateY(-2px);
    box-shadow: 0 6px 12px rgba(0, 123, 255, 0.4);
  }

  &:active {
    transform: translateY(0);
  }
`;

export const PrimaryButton = styled.button`
  padding: 10px 20px;
  background: linear-gradient(135deg, #007bff, #0056b3);
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  box-shadow: 0 4px 8px rgba(0, 123, 255, 0.3);
  transition: all 0.3s ease;

  &:hover {
    background: linear-gradient(135deg, #0056b3, #007bff);
    transform: translateY(-2px);
    box-shadow: 0 6px 12px rgba(0, 123, 255, 0.4);
  }

  &:active {
    transform: translateY(0);
  }
`;

export const SecondaryButton = styled.button`
  padding: 10px 20px;
  background: linear-gradient(135deg, #6c757d, #545b62);
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  box-shadow: 0 4px 8px rgba(108, 117, 125, 0.3);
  transition: all 0.3s ease;

  &:hover {
    background: linear-gradient(135deg, #545b62, #6c757d);
    transform: translateY(-2px);
    box-shadow: 0 6px 12px rgba(108, 117, 125, 0.4);
  }

  &:active {
    transform: translateY(0);
  }
`;

export const WarningButton = styled.button`
  padding: 6px 12px;
  background: linear-gradient(135deg, #ffc107, #ff9800);
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  box-shadow: 0 4px 8px rgba(255, 193, 7, 0.3);
  transition: all 0.3s ease;
  margin-right: 5px;

  &:hover:not(:disabled) {
    background: linear-gradient(135deg, #ff9800, #ffc107);
    transform: translateY(-2px);
    box-shadow: 0 6px 12px rgba(255, 193, 7, 0.4);
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }

  &:disabled {
    background: linear-gradient(135deg, #6c757d, #5a6268);
    cursor: not-allowed;
    box-shadow: none;
    opacity: 0.6;
  }
`;

export const DangerButton = styled.button`
  padding: 6px 12px;
  background: linear-gradient(135deg, #dc3545, #c82333);
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  box-shadow: 0 4px 8px rgba(220, 53, 69, 0.3);
  transition: all 0.3s ease;

  &:hover:not(:disabled) {
    background: linear-gradient(135deg, #c82333, #dc3545);
    transform: translateY(-2px);
    box-shadow: 0 6px 12px rgba(220, 53, 69, 0.4);
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }

  &:disabled {
    background: linear-gradient(135deg, #6c757d, #5a6268);
    cursor: not-allowed;
    box-shadow: none;
    opacity: 0.6;
  }
`;

export const InfoButton = styled.button`
  padding: 10px 20px;
  background: linear-gradient(135deg, #17a2b8, #138496);
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 600;
  box-shadow: 0 4px 8px rgba(23, 162, 184, 0.3);
  transition: all 0.3s ease;

  &:hover {
    background: linear-gradient(135deg, #138496, #17a2b8);
    transform: translateY(-2px);
    box-shadow: 0 6px 12px rgba(23, 162, 184, 0.4);
  }

  &:active {
    transform: translateY(0);
  }
`;
